module.exports = __webpack_public_path__ + "static/img/situation_0.1a4c82e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/situation_0.jpg
// module id = fiW/
// module chunks = 1